<template lang="pug">
.banner2.py-sm-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  :style="`min-height: calc(100vh - ${$vuetify.application.top}px)`"
)
  v-container(fluid)
    v-row
      v-col
        v-row(justify="start" align="center")
          v-col(cols="auto")
            h2.mb-4.ibm.text-h4.text-sm-h3.text-md-h2.font-weight-regular.grey--text.text--darken-4 A forma de trabalhar mudou.<br>E a sua equipe?
        v-row(justify="start" align="center")
          v-col(cols="auto")
            .mb-4.text-body-1.text-md-h6.font-weight-regular.heebo.grey--text.text--darken-4(
              style="max-width: 464px"
            ) Investir em aprendizado para seus colaboradores é investir em resultados para a sua empresa.
        v-row(justify="start" align="center")
          v-col(cols=12 md="auto")
            v-btn.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
              color="primary"
              depressed
              :block="$vuetify.breakpoint.xsOnly"
              height=56
              @click="$router.push('/contato')"
            ) Começar a mudança!
</template>

<script>
export default {
  components: {}
}
</script>

<style lang="sass" scoped></style>
